<template>
  <div v-show="isRenewContract && dataContracts.length > 0">
    <div class="alert-contract" role="alert">
      <div class="close-box">
        <v-btn class="close" icon @click="isRenewContract = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-btn class="close" icon @click="isSettingDialog = true">
          <v-icon>mdi-cog-outline</v-icon>
        </v-btn>
      </div>
      <div class="media" @click="dialogRenewContracts = true">
        <div class="media-left">
          <v-btn text class="btn-renew-contract">
            <img width="60px" class="media-object" src="../assets/images/megaphone-icon.svg" alt="megaphone-icon" />
          </v-btn>
        </div>
        <div class="media-body">
          <h4 class="media-heading" style="line-height: unset;">
            <v-btn color="info " text class="btn-renew-contract">
              <b>{{ this.$t('contract.have_contract_stall_expired') }}</b>
            </v-btn>
          </h4>
          <span>
            {{ $t('product.quantity') }}
            <b v-if="!isLoading && !isLoadingContractCheckout">{{ dataContracts.length }}</b>
            <b v-else>...</b>
            {{ $t('area.space') }}
          </span>
        </div>
      </div>
    </div>
    <template>
      <v-dialog v-model="dialogRenewContracts" max-width="1300" persistent scrollable>
        <v-card flat outlined :loading="isLoading" min-height="30">
          <v-card-title class="d-flex justify-space-between align-center">
            <div class="d-flex justify-space-between" style="width: 100%">
              <span>{{ $t('contract.renew_area_contract') }}</span>
              <v-btn color="black" icon @click="dialogRenewContracts = false; isAll = false,$emit('onClose',true)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <div class="d-flex justify-space-between align-center m-2 px-2">
            <div>
              <v-btn outlined color="info" style="margin-left:10px;" @click="isAll = !isAll; updateThreshold()">
                <v-icon v-if="isAll">mdi-calendar-filter</v-icon>
                <v-icon v-else>mdi-filter-variant</v-icon>
                {{ !isAll ? $t('contract.show_all_contract') : $t('contract.show_only_contract_will_expired') }}
              </v-btn>
              <v-btn icon color="info" style="margin-left:10px;" @click="initMarketArea()">
                <v-icon>mdi-reload</v-icon>
              </v-btn>
            </div>
            <div>
              <span class="gray--text" v-if="seleteContracts.length <= 0">{{ $t('validate.please_select_contract_to_renew') }}</span>
              <v-btn color="info" :disabled="seleteContracts.length <= 0" style="margin-left:10px;"
                @click="clickRenewContracts()">
                <v-icon>mdi-plus</v-icon>
                {{ $t('validate.renew_contract_count',{ count: seleteContracts.length }) }}
              </v-btn>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-text style="padding:0;">
            <v-card v-if="isLoading || isLoadingContractCheckout" class="my-20 d-flex justify-center align-center" elevation="0">
              <v-progress-circular indeterminate color="green" size="70"></v-progress-circular>
            </v-card>
            <v-data-table
              v-else
              :loading="isLoading || isLoadingContractCheckout"
              :headers="headers"
              v-model="seleteContracts"
              :items-per-page="50"
              :items="dataContracts"
              class="border-2 data-table-renew"
              sort-by="contractId"
              item-key="objectId"
              :show-select="true"
              @toggle-select-all="selectAllToggle"
              :no-data-text="$t('noinfo')"
              :no-results-text="$t('no_matching_records_found')">
              <template v-slot:item.data-table-select="{ item, isSelected, select }">
                <v-simple-checkbox v-if="item.checkRenew" 
                :value="isSelected"
                @input="select($event)" 
                ></v-simple-checkbox>
                <v-tooltip top v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-simple-checkbox v-bind="attrs" v-on="on" readonly disabled></v-simple-checkbox>
                  </template>
                  <span v-if="item.isSuspend">{{ $t('suspend.cannot_renew_contract_because_of_suspend') }}</span>
                  <span v-else-if="item.renewAppeal">{{ $t('validate.waiting_for_approval') }}</span>
                </v-tooltip>
              </template>

              <template v-slot:header.customerFullName="{header}">
                <span>
                  <div class="text-nowrap-table text-center" style="min-width:120px">{{header.text}}</div>
                </span>
              </template>
              <template v-slot:header.businessName="{header}">
                <div class="text-nowrap-table text-center" style="min-width:120px">{{header.text}}</div>
              </template>
              <template v-slot:header.areasText="{header}">
                <div class="text-nowrap-table text-center" style="min-width:120px;">{{header.text}}</div>
              </template>

              <template v-slot:item.contractId="{ item }">{{ item.contractId }}</template>
              <template v-slot:item.customerFullName="{ item }">
                <div class="customer-name text-truncate"> {{ item.customerFullName }} </div>
              </template>
              <template v-slot:item.businessName="{ item }">
                <div class="business-name text-truncate"> {{ item.businessName }} </div>
              </template>
              <template v-slot:item.areasText="{ item }">
                <div class="area-name text-truncate"> {{ item.areasText }} </div>
              </template>
              <template v-slot:item.stallType="{ item }">{{ item.stallType ? $t(`contact.stall_type.${item.stallType}`) : '-' }}</template>
              <template v-slot:item.status="{ item }">
                <v-chip :class="item.status.color" @click="openContractDialog(item)">{{ item.status.text }}</v-chip>
              </template>
              <template v-slot:item.startDate.iso="{ item }">{{ dateFormat(item.startDate) }}</template>
              <template v-slot:item.endDate.iso="{ item }">{{ dateFormat(item.endDate) }}</template>
              <template v-slot:item.ageExpireStatus="{ item }">
                <v-chip v-if="item.ageExpireStatus" :color="item.ageExpireStatus.color">{{
                  item.ageExpireStatus.text }}</v-chip>
              </template>

            </v-data-table>
          </v-card-text>
          
        </v-card>
      </v-dialog>
      <ContractDetailDialog v-model="isContractDialog" :contractId="tempContract ? tempContract.objectId : null"
        :show-area="true" :projectId="projectId" :marketId="marketId" initTab="Bill"></ContractDetailDialog>
      <RenewContractDialog v-model="dialogRenewContract" :marketId="marketId" :projectId="projectId"
        :contracts="seleteContracts" @onSuccess="onSuccessRenew" />
      <ContractExpiredSettingDialog v-model="isSettingDialog" :marketId="marketId" @onSuccess="initData();$emit('onSuccessSetting',true)" />
    </template>
  </div>
</template>
  
  
<script>
import { BillingSetting, AreaAccountingProduct, ContractTemplate } from "../classes"
import { mapGetters, mapActions, mapMutations } from "vuex";
import ContractDetailDialog from "./ContractDetailDialog";
import RenewContractDialog from "./RenewContractDialog";
import ContractExpiredSettingDialog from "./ContractExpiredSettingDialog";
import { ContractCheckout } from "../classes";
export default {
  components: {
    ContractDetailDialog,
    RenewContractDialog,
    ContractExpiredSettingDialog
  },
  props: {
    // projectId: String,
    // marketId: String
    openRenewDialog : Boolean,
    selectedRenewItem: Object,
  },
  computed: {
    ...mapGetters({
      contracts: "area/getContracts",
      getAdminByMarketId: "admin/getByMarketId",
      getEmployeeByMarketId: "employee/getByMarketId",
    }),
    admin() {
      return this.getAdminByMarketId(this.marketId);
    },
    employee() {
      return this.getEmployeeByMarketId(this.marketId);
    },
    selectedContract(){
      if(this.selectedRenewItem){
        let item =  this.dataContracts.filter(a => a.objectId == this.selectedRenewItem.contract.objectId)
        if(item.length > 0 && item[0].checkRenew){
          this.seleteContracts = [...item];
        }else{
          this.seleteContracts = [];
        }
      }else{
        this.seleteContracts = [];
      }
    }
  },
  watch: {
    isContractDialog(val) {
      if (val === false) this.initMarketArea()
    },
    contracts(val) {
      this.updateThreshold()
      this.updateContractCheckout()
    },
    dialogRenewContracts(val) {
      this.seleteContracts = [];
      if (val) {
        this.initMarketArea();
      }
    },
    openRenewDialog(val) {
      if (val) {
        this.dialogRenewContracts = true;
      };
    },
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      project: null,
      market: null,
      isAll: false,
      isLoading: false,
      seleteContracts: [],
      disabledCount: 0,
      dialogRenewContracts: false,
      dialogRenewContract: false,
      isRenewContract: true,
      headers: [],
      dialogStartDate: false,
      dialogEndDate: false,
      dialogEffectiveDate: false,
      dateTimeFormat: "YYYY-MM-DD",
      isContractDialog: false,
      tempContract: null,
      dataContracts: [],
      isSettingDialog: false,
      formSetting: {
        contractExpiredThresholdDays: null
      },
      isLoadingContractCheckout: false,
      contractCheckouts: [],
    };
  },
  created() {
    if (this.admin) {
      this.project = this.admin.project;
      this.market = this.admin.market;
    }
    if (this.employee) {
      this.project = this.employee.project;
      this.market = this.employee.market;
    }

    this.headers = [
        {
          value: "contractId",
          text: this.$t('contract.contract_number_only'),
          width: "200px",
          align: "center"
        },
        {
          value: "businessName",
          text: this.$t('contract.business_name'),
          width: "1%",
          align: "center hd-resize text-truncate",
          sortable: false,
        },
        {
          value: "customerFullName",
          text: this.$t('contract.contract_owner_name'),
          width: "1%",
          align: "center hd-resize text-truncate",
          sortable: false,
        },
        {
          value: "areasText",
          text: this.$t('area.space'),
          width: "1%",
          align: "center hd-resize text-truncate",
          class : "custom-sort",
        },
        {
          value: "stallType",
          text: this.$t('area.stall_type'),
          align: "center",
          class : "text-no-wrap",
        },
        {
          value: "status",
          text: this.$t('status'),
          align: "center",
          width: "100px"
        },
        {
          value: "startDate.iso",
          text: this.$t('start_date'),
          align: "center",
          width: "100px"
        },
        {
          value: "endDate.iso",
          text: this.$t('end_date'),
          align: "center",
               width: "100px"
        },
        {
          value: "ageExpireStatus",
          text: "",
          sortable: false,
          align: "center",
        },
    ];
  },
  mounted() {
    this.initData();
  },
  methods: {
    ...mapActions({
      getContract: "contract/getContract",
      getContracts: "contract/getContracts",
      renewContract: "contract/renewContract",
      createContractDocument: "contractDocument/createContractDocument",
    }),
    async initData() {
      this.isLoading = true;
      try {
        this.market = await this.$store.dispatch("markets/getMarket", { marketId: this.marketId, force: true })
        this.updateThreshold()
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        this.$toast.show({
          content: this.$t('contract.error_get_contract'),
          color: "error"
        });
      }
    },
    async initMarketArea() {
      this.isLoading = true;
      try {
        await this.$store.dispatch("markets/getMarketArea", {
          id: this.marketId
        });
        this.updateThreshold()
        await this.updateContractCheckout()
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        this.$toast.show({
          content: this.$t('contract.error_get_contract'),
          color: "error"
        });
      }
    },
    updateThreshold() {
      for (let contract of this.contracts || []) {
        contract.expiredThresholdDays = this.market?.setting?.contractExpiredThresholdDays || 90
        this.formSetting.contractExpiredThresholdDays = this.market?.setting?.contractExpiredThresholdDays || 90
      }
      this.seleteContracts = [];
      this.dataContracts = [];
      if (this.contracts) this.disabledCount = 0;
      for (const contract of this.contracts) {
        if (contract.isActive && !contract.isRenewEffective && !contract.isNotCheckInArea) {
          if (this.isAll) {
            this.dataContracts.push(contract);
            if (!contract.checkRenew) this.disabledCount += 1;
          } else {
            if (contract.alertAgeExpire) {
              this.dataContracts.push(contract);
              if (!contract.checkRenew) this.disabledCount += 1;
            }
          }
        }
      }
    },
    async updateContractCheckout() {
      this.isLoadingContractCheckout = true;
      try {
        this.contractCheckouts = await ContractCheckout.getContractCheckoutByContractIds({
          contractIds: this.dataContracts.map(c => c.objectId),
          status: ["pending", "draft"]
        });
        for (let contractCheckout of this.contractCheckouts) {
          let index = this.dataContracts.findIndex(c => c.objectId == contractCheckout.contract.objectId)
          if (index != -1) {
            this.dataContracts.splice(index, 1)
          }
        }
        this.isLoadingContractCheckout = false;
      } catch (e) {
        this.isLoadingContractCheckout = false;
        this.$toast.show({
          content: this.$t('contract.error_get_contract'),
          color: "error"
        });
      }
    },
    clickRenewContracts() {
      this.dialogRenewContract = true;
    },
    async onSuccessRenew() {
      await this.initMarketArea();
    },
    printContract(template) {
      this.tempContractTemplate = template
      this.isDocumentEditorDialog = true
    },
    selectAllToggle(props) {
      if (
        this.seleteContracts.length !=
        this.dataContracts.length - this.disabledCount
      ) {
        this.seleteContracts = [];
        const self = this;
        props.items.forEach(item => {
          if (item.checkRenew) {
            self.seleteContracts.push(item);
          }
        });
      } else this.seleteContracts = [];
    },
    fullName(data) {
      let res = "-";
      if (data && data.type == "company") {
        res = `${data.companyName}`;
      } else if (data && data.type == "personal") {
        res = `${data.title} ${data.firstName} ${data.lastName}`;
      }
      return res;
    },
    dateFormat(date, isCheckExpire = false) {
      let res = "-";
      if (date && date.iso) {
        if (isCheckExpire) {
          let age = this.ageExpire(date);
          res = `${this.$moment(date.iso).format("DD/MM/YYYY")} (${age < 0 ? this.$t('already_expired') : this.$t('in_another') + " " + age + " " + this.$t('day')
            })`;
        } else {
          res = this.$moment(date.iso).format("DD/MM/YYYY");
        }
      }
      return res;
    },
    ageExpire(date) {
      let res = 0;
      if (date && date.iso) {
        res = this.$moment(date.iso).diff(this.$moment(), "days") - 1;
      }
      return res;
    },
    checkDisabledRatio() {
      let res = false
      if (this.form.startDate_tmp) res = this.$moment(this.form.startDate_tmp, this.dateTimeFormat).endOf('day').isSameOrBefore(this.$moment().endOf('day'))
      return res
    },
    openContractDialog(contract) {
      this.tempContract = contract
      this.isContractDialog = true
    },
  }
};
</script>
  
  
<style lang="scss" scoped>

.data-table-renew::v-deep th.custom-sort {
  position: relative;
  .v-icon{
    position: absolute;
    right: 10px;
    top: 15px;
  }
}

.data-table-renew::v-deep td.hd-resize{
  max-width: 120px;
}

.alert-contract {
  position: relative;
  margin-bottom: 10px;
  background: #fffc97;
  animation: zoomIn 0.4s;
  -webkit-animation: zoomIn 0.4s;
  border-color: #fffc97;
  border: 1px solid transparent;
  border-radius: 4px;
  transition: transform 0.3s ease;
}

.alert-contract:hover {
  transform: scale(1.01);
}

.media {
  cursor: pointer;
  padding: 15px;
  margin-top: 0;
  overflow: hidden;
  zoom: 1;
}

.media-body,
.media-left {
  display: table-cell;
  vertical-align: top;
}

.media-left {
  padding-right: 10px;
}

.media-object {
  display: block;
}

.media-heading {
  margin-top: 0;
  margin-bottom: 5px;
  line-height: unset;
}

.btn-renew-contract {
  height: unset !important;
  padding: 0 !important;
  font-size: 18px;
  letter-spacing: 0;
}

.close-box {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  top: 0;
  right: 0;
  align-items: flex-end;
  height: 100%;
  padding: 5px 10px;
}

.close {
  font-size: 21px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.2);
  background: #fff;
}

.v-data-table::v-deep th {
  color: #000;
  font-size: 1rem !important;
  text-align: center !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}


.v-data-table::v-deep td {
  font-size: 1rem !important;
  text-align: center !important;
  padding: 0 10px !important;
  max-width: 200px;
}


.confirm-renew-box {
  display: flex;
  flex-wrap: wrap;


  .col-1 {
    width: 100%;
    max-width: 100%;
    flex-basis: 100%;
  }


  .col-2 {
    width: 50%;
    max-width: 50%;
    min-width: 250px;
    flex-basis: 50%;
  }


  .space-between {
    display: flex;
    justify-content: space-between;
  }
}


@keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}


.text-nowrap-table.area-name,
.text-nowrap-table.customer-name {
  width: 100%;
}

.warning-note {
  color: var(--v-warning-base);
  font-size: 18px;
  padding-left: 15px;
}

.red-note-head {
  color: var(--v-error-base);
  font-size: 20px;
  align-items: baseline;
  vertical-align: bottom;
}

.red-note {
  color: var(--v-error-base);
  font-size: 14px;
  padding-left: 15px;
}
</style>
  
  